import React from 'react'

import { type MobileStateProps } from '@/components/atoms/MobileState/MobileState.tsx'

type TeamsMobileStatusContextValue = Record<string, MobileStateProps['state']>

export const TeamsMobileStatusContext = React.createContext<TeamsMobileStatusContextValue>({})

export interface TeamsMobileStatusProviderProps {
  status?: TeamsMobileStatusContextValue
  children: React.ReactNode
}

export const TeamsMobileStatusProvider: React.FC<TeamsMobileStatusProviderProps> = ({ status = {}, children }) => (
  <TeamsMobileStatusContext.Provider value={status}>{children}</TeamsMobileStatusContext.Provider>
)
